import { ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';
import { IdName } from '@api/models/idname';

export interface FilterOption {
  key?: any;
  value?: string;
}

export interface DateRangeValidationConfig {
  minDate?: DateTime;
  maxDate?: DateTime;
  maxRangeDays?: number;
  minRangeDays?: number;
  allowFutureDates?: boolean;
}

export interface FilterConfig {
  controlName: string;
  label: string;
  type?: FilterInputType;
  infoTooltip?: string;
  value?: any;
  options?: FilterOption[];
  visible: boolean;
  required?: boolean;
  placeholder?: string;
  multiple?: boolean;
  disabled?: boolean;
  selectAll?: boolean;
  dependsOn?: {
    key: string;
    value: any;
  }[];
  validators?: ValidatorFn[];
  dateRangeGroupKey?: string; // e.g. 'customRange'
  dateRangeValidation?: DateRangeValidationConfig;
  params?: any;
  onSearch?: (term: string) => void;
  onLoadMore?: (params: any) => void;
  getOptions?: (term: string) => void;
}

export enum FilterInputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Select = 'select',
  Date = 'date',
  Checkbox = 'checkbox',
  DateRange = 'dateRange',
  WeekRange = 'weekRange',
  Combobox = 'combobox',
}

type BaseDateFilterConfig = Omit<FilterConfig, 'options' | 'multiple' | 'selectAll' | 'dateRangeGroupKey' | 'dateRangeValidation'> & {};

type BaseInputConfig = {
  controlName: string;
  label: string;
  placeholder?: string;
  value?: any;
  visible: boolean;
  validators?: ValidatorFn[];
};

export type TextFilterConfig = BaseInputConfig & {};

export type NumberFilterConfig = BaseInputConfig & {
  min?: number;
  max?: number;
  step?: number;
};

export type EmailFilterConfig = BaseInputConfig & {};

export type PasswordFilterConfig = BaseInputConfig & {};

export type SelectFilterConfig = BaseInputConfig & {
  options: (FilterOption | IdName)[];
  multiple?: boolean;
  selectAll?: boolean;
};

export type CheckboxFilterConfig = Omit<FilterConfig, 'type' | 'options' | 'multiple' | 'selectAll' | 'dateRangeGroupKey' | 'dateRangeValidation'> & {
  value: boolean;
};

export type DateFilterConfig = BaseDateFilterConfig & {
  dateRangeGroupKey?: string;
  dateRangeValidation?: DateRangeValidationConfig;
};

export type DateRangeFilterConfig = BaseDateFilterConfig & {};

export type WeekRangeFilterConfig = BaseDateFilterConfig & {};

export type ComboboxFilterConfig = FilterConfig & {
  placeholder?: string;
  options: (FilterOption | IdName)[];
  multiple?: boolean;
  selectAll?: boolean;
  params?: any;
  onSearch?: (term: string) => void;
  onLoadMore?: (params: any) => void;
};